module.exports = __webpack_public_path__ + "img/scene2@2x.8515f05f.png";